import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "favorite-button item" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 1,
  class: "loader",
  "data-color": "blue"
}

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddProfileFavorite',
  props: {
    itemIdMaster: {},
    itemType: {},
    isFavoritePage: { type: Boolean }
  },
  emits: ["updateData"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const localizer = Localizer;
const isLoading = ref(false);
const isFavorite = ref(false);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onMounted(async () => {
	isLoading.value = true;
	isFavorite.value = (await Axios.post(routes.PrivateArea_GetProfileFavorite, { ItemIdMaster: props.itemIdMaster })).data;
	isLoading.value = false;
});

async function setProfileFavorite() {
	validationErrors.value = [];
	isLoading.value = true;

	try {
		await Axios.post(routes.PrivateArea_SetProfileFavorite, { ItemIdMaster: props.itemIdMaster, ItemType: props.itemType });
		isFavorite.value = true;

		store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileFavorite_AddSuccess"), type: "Success" });

		GTagHelper.sendEvent("click", "render_favorite", "add");
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	isLoading.value = false;
}

async function removeProfileFavorite() {
	validationErrors.value = [];
	isLoading.value = true;

	try {
		await Axios.post(routes.PrivateArea_RemoveProfileFavorite, { ItemIdMaster: props.itemIdMaster });

		store.dispatch("accountAreaToastStore/onAddToast", { message: localizer.get("PrivateArea.Common.Asset_ProfileFavorite_RemoveSuccess"), type: "Success" });

		GTagHelper.sendEvent("click", "render_favorite", "remove");

		if (props.isFavoritePage) {
			emit("updateData");
		}
		isFavorite.value = false;
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
		for (const validationError of validationErrors.value) {
			store.dispatch("accountAreaToastStore/onAddToast", { message: validationError.message, type: "Warning" });
		}
	}

	isLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!isFavorite.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setProfileFavorite()), ["prevent"])),
                class: "button"
              }, [
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "icon fastic-star" }, null, -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileFavorite_AddToFavorite")), 1)
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (removeProfileFavorite()), ["prevent"])),
                class: "button"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "icon fastic-star-full active" }, null, -1)),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(localizer).get("PrivateArea.Common.Asset_ProfileFavorite_RemoveToFavorite")), 1)
              ]))
        ], 64))
      : (_openBlock(), _createElementBlock("span", _hoisted_4))
  ]))
}
}

})